import { lazy } from 'react';

export const BusinessProfileIndexLazy = lazy(() => import('./index'));
